import client_lookups from '@/assets/json/clientLookups.json'
import i18n from '@/i18n/i18n'
import { useFormStore } from '@/stores/form'
import { notify } from 'notiwind'

export default function () {
  const formStore = useFormStore()

  const {
    transactionReason: {
      holdersOfDoctorateDegrees,
      graduatesofAccreditedUniversitiesInUAE,
      graduatesofAccreditedUniversitiesOutsideUAE
    }
  } = client_lookups

  const { transactionReasonId, certificateAttestedFromMinistryOrHigherEducation } =
    formStore.form.values

  if (
    transactionReasonId == holdersOfDoctorateDegrees &&
    certificateAttestedFromMinistryOrHigherEducation == 2
  ) {
    notify(
      {
        group: 'error',
        title: i18n.global.t('certificateMustAttestedFromMinistryOrHigherEducation')
      },
      6000
    )
    return false
  }

  const graduateReasons = [
    graduatesofAccreditedUniversitiesInUAE,
    graduatesofAccreditedUniversitiesOutsideUAE
  ]

  if (
    graduateReasons.includes(transactionReasonId) &&
    certificateAttestedFromMinistryOrHigherEducation == 2
  ) {
    notify(
      {
        group: 'error',
        title: i18n.global.t('certificateMustAttestedFromMinistry')
      },
      6000
    )

    return false
  }

  return true
}
